import React from 'react';

export const GoogleDriveSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_2230_18945)">
			<path
				d="M7.26804 29.8189L8.59107 32.1635C8.86598 32.6571 9.26117 33.0449 9.72509 33.3269L14.4502 24.9359H5C5 25.4824 5.13746 26.0288 5.41237 26.5224L7.26804 29.8189Z"
				fill="#0066DA"
			/>
			<path
				d="M20 15.0641L15.2749 6.6731C14.811 6.95515 14.4158 7.34297 14.1409 7.83656L5.41237 23.3494C5.14251 23.8323 5.00036 24.3792 5 24.9359H14.4502L20 15.0641Z"
				fill="#00AC47"
			/>
			<path
				d="M30.2751 33.3269C30.739 33.0449 31.1342 32.6571 31.4091 32.1635L31.9589 31.1939L34.5878 26.5224C34.8627 26.0288 35.0002 25.4824 35.0002 24.9359H25.5493L27.5603 28.9904L30.2751 33.3269Z"
				fill="#EA4335"
			/>
			<path
				d="M20.0001 15.0641L24.7252 6.67308C24.2613 6.39103 23.7286 6.25 23.1788 6.25H16.8214C16.2716 6.25 15.7389 6.40865 15.275 6.67308L20.0001 15.0641Z"
				fill="#00832D"
			/>
			<path
				d="M25.5497 24.9359H14.4501L9.72498 33.3269C10.1889 33.609 10.7215 33.75 11.2714 33.75H28.7284C29.2782 33.75 29.8109 33.5913 30.2748 33.3269L25.5497 24.9359Z"
				fill="#2684FC"
			/>
			<path
				d="M30.2234 15.593L25.8591 7.83656C25.5842 7.34297 25.189 6.95515 24.7251 6.6731L20 15.0641L25.5498 24.9359H34.9828C34.9828 24.3894 34.8454 23.843 34.5704 23.3494L30.2234 15.593Z"
				fill="#FFBA00"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2230_18945">
				<rect width="30" height="27.5" fill="white" transform="translate(5 6.25)" />
			</clipPath>
		</defs>
	</svg>
);
